import { isPreOrderActive } from './Campaign.service'

const defaultState = {
  campaign: {
    isPreOrderActive: isPreOrderActive()
  }
}

const getters = {
  isPreOrderActive: (state) => state.campaign.isPreOrderActive
}

export default {
  state: defaultState,
  getters
}
